export enum NotificationType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warn',
  ERROR = 'error',
}
